import { useMq } from "../common/mediaquery";

interface options {
  trigger: string;
  only?: 'sp' | 'pc';
}

export function sortUi(obj: options) {
  class SortUi {
    triggers: NodeListOf<Element>;
    scrollPos: number;
    wrapElement: HTMLElement;
    wrapElementInner: HTMLElement;
    body: HTMLBodyElement;
    closeTriggers: NodeListOf<Element>;

    constructor() {
      this.body = document.querySelector('body');
      this.triggers = document.querySelectorAll(`.${obj.trigger}`);
      this.scrollPos = window.scrollY; 
      this.wrapElement = document.querySelector(".o-sort_overlay");
      this.wrapElementInner = document.querySelector(".o-sort_overlay-list");
      this.closeTriggers = document.querySelectorAll('.js-sort-close');
      this.init();
    }

    init() {
      if(this.triggers.length === 0) return;
      useMq({
        type: 'max',
        query: '767px',
        onMatch: () => {
          Array.prototype.forEach.call(this.triggers, (trigger) => {
            this.sortModalOpen(trigger);
          });
          Array.prototype.forEach.call(this.closeTriggers, (trigger) => {
            this.sortModalClose(trigger);
          });
        },
        onUnmatch: () => {
          Array.prototype.forEach.call(this.triggers, (trigger) => {
            this.sortDropdown(trigger);
          });
        }
      });
    }

    sortModalOpen(trigger) {
      const clickButton = trigger.querySelector('.o-sort-ui_select-button');

      clickButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.scrollPos = window.scrollY;
        const sortElm = event.currentTarget.nextElementSibling.children[0].cloneNode(true);
        this.wrapElementInner.innerHTML = '';
        this.wrapElementInner.appendChild(sortElm);
        this.wrapElement.classList.add('is-open');
      });
    }

    sortModalClose(trigger) {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.wrapElementInner.innerHTML = '';
        this.wrapElement.classList.remove('is-open');
      });
    }

    sortDropdown(trigger) {
      const clickButton = trigger.querySelector('.o-sort-ui_select-button');

      clickButton.addEventListener('click', (event) => {
        event.preventDefault();
        const clickButtons = document.querySelectorAll('.o-sort-ui_select-button');

        Array.prototype.forEach.call(clickButtons, (button) => {
          if(button !== event.currentTarget) {
            button.classList.remove('is-active');
            button.nextElementSibling.classList.remove('is-open');
          }
        });

        const sortElm = event.currentTarget.nextElementSibling;
        event.currentTarget.classList.toggle('is-active');
        sortElm.classList.toggle('is-open');
      });

      clickButton.addEventListener('blur', (event) => {
        event.preventDefault();
        const sortElm = event.currentTarget.nextElementSibling;
        sortElm.classList.remove('is-open');
        event.currentTarget.classList.remove('is-active');
      });
    }
  }

  new SortUi();
}